module.exports = __webpack_public_path__ + "media/images/mamari/wowma/icon-arrow-next-6e097f96f8082e6db4cf84548b8ac26f.png";